import { get, set } from "lodash";
export default function setIfNotSet(obj, key, value) {
    if (get(obj, key, null) === null) {
        set(obj, key, value);
    }
}
